import { useEffect, useState } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import styled from 'styled-components';

import FilterCard from './FilterCard';
import { devicesAtom } from '@/interfaces/devices';
import { filterdListAtom } from '@/components/devices/Filter';
import { selectedDeviceAtom } from '@/components/common/MapView';

import type { Device, DeviceStatus } from '@/@types/device';

const Layout = styled.div`
  position: absolute;
  top: 0;
  margin: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  transition: translate 0.3s, opacity 0.3s;

  &.hide {
    translate: 0 -150%;
    opacity: 0;
  }
`;

export type HomeFilterStatus = 'all' | DeviceStatus | 'keyword';

export default function Home() {
  const [{ data: deviceList }] = useAtom(devicesAtom);
  const selectedDevice = useAtomValue(selectedDeviceAtom);
  const layoutClass = selectedDevice ? 'hide' : '';
  const { t } = useTranslation();

  const [keyword, setKeyword] = useState<string>();
  const [selected, setSelected] = useState<HomeFilterStatus>();

  const setFilterdList = useSetAtom(filterdListAtom);

  useEffect(() => {
    if (deviceList) {
      listFilter('all', keyword);
    }
  }, [deviceList]);

  const listFilter = (selectedVal: HomeFilterStatus, keyword: string) => {
    let retList: Device[] = deviceList;
    switch (selectedVal) {
      case 'online':
        retList = deviceList.filter((target: Device) => target.status === 'online');
        break;
      case 'offline':
        retList = deviceList.filter((target: Device) => target.status === 'offline');
        break;
      case 'alarm':
        retList = deviceList.filter((target: Device) => target.status !== 'online' && target.status !== 'offline');
        break;
      case 'all':
      default:
        break;
    }
    if (keyword && keyword !== '') {
      retList = retList.filter((target: Device) => target.name.indexOf(keyword) > -1);
    }
    setFilterdList(retList);
  };

  const handleClick = (cardName: HomeFilterStatus) => {
    const targetName: HomeFilterStatus = selected !== cardName ? cardName : 'all';
    setSelected(targetName);
    listFilter(targetName, keyword);
  };
  const handleSearchChange = (val: string) => {
    setKeyword(val);
  };
  const handleSearchKeydown = (key: string) => {
    if (key === 'Enter') {
      listFilter(selected, keyword);
    }
  };

  return (
    <Layout className={layoutClass}>
      <TextField
        id="input-with-icon-textfield"
        label={t('Common.label.search')}
        sx={{
          bgcolor: '#ffffff',
          flexGrow: 1,
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
        onChange={(e) => handleSearchChange(e.target.value)}
        onKeyDown={(e) => handleSearchKeydown(e.key)}
      />
      <div onClick={() => handleClick('online')}>
        <FilterCard
          cardName={'online'}
          count={deviceList && deviceList.filter((device) => device.status === 'online').length}
          selected={selected === 'online'}
        />
      </div>
      <div onClick={() => handleClick('offline')}>
        <FilterCard
          cardName={'offline'}
          count={deviceList && deviceList.filter((device) => device.status === 'offline').length}
          selected={selected === 'offline'}
        />
      </div>
      <div onClick={() => handleClick('alarm')}>
        <FilterCard
          cardName={'alarm'}
          count={deviceList && deviceList.filter((device) => device.status === 'alarm').length}
          selected={selected === 'alarm'}
        />
      </div>
    </Layout>
  );
}
